import {Component, computed, inject, OnInit, Signal} from '@angular/core';
import {ContentComponent} from '../../components/content/content.component';
import {BreadcrumbsComponent} from '../../common/breadcrumbs/breadcrumbs.component';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {Store} from '@ngrx/store';
import {RouterLink} from '@angular/router';
import {loadFormData, updateFormData} from '../../store/actions/my-settings.actions';
import {selectFormData, selectLoading, selectPending} from '../../store/selectors/my-settings.selectors';
import {AlertContainerComponent, AlertService} from '../../common/alert-container/alert-container.component';
import {SpinnerComponent} from '../../common/spinner/spinner.component';
import {NotificationForm} from "./forms/notification.form";
import {NotificationFormComponent} from "./components/notification-form/notification-form.component";

@Component({
  selector: 'app-my-settings-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    ReactiveFormsModule,
    CommonModule,
    RouterLink,
    AlertContainerComponent,
    SpinnerComponent,
    NotificationFormComponent
  ],
  providers: [],
  templateUrl: './my-settings-page.component.html'
})
export class MySettingsPageComponent implements OnInit {

  public form: Signal<NotificationForm> = computed(() => {
    const v = this.store$.selectSignal(selectFormData);
    const f = new NotificationForm().initForm(v());
    f.disable()
    return f;
  });

  private store$: Store = inject(Store);

  private alertService: AlertService = inject(AlertService);

  public loading = this.store$.selectSignal(selectLoading);

  public pending = this.store$.selectSignal(selectPending);

  public onSubmit(): void {
    if (this.form().valid) {
      this.store$.dispatch(
        updateFormData({
          payload: {
            preferences: this.form().preferenceValues,
            subscribedAreas: this.form().subscribedAreaValues
          },
          successFnc: () => {
            this.alertService.show({
              title: 'Sukces!',
              content: 'Twoje ustawienia zostały zaktualizowane.',
              type: 'success'
            });
          },
          failureFnc: () => {
            this.alertService.show({
              title: 'Uwaga!',
              content: 'Twoje ustawienia nie zostały zaktualizowane!',
              type: 'danger'
            });
          }
        })
      );
    } else {
      this.form().markAllAsTouched();
    }
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadFormData());
  }
}
